import { render, staticRenderFns } from "./adminkf2.vue?vue&type=template&id=5133eec0"
import script from "./adminkf2.vue?vue&type=script&lang=js"
export * from "./adminkf2.vue?vue&type=script&lang=js"
import style0 from "./adminkf2.vue?vue&type=style&index=0&id=5133eec0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports